export default {
  offer: "OFFER_TYPE_OFFER",
  counter: "OFFER_TYPE_COUNTER",
  turbo: "OFFER_TYPE_TURBO"
};
